import { render, staticRenderFns } from "./newOrderAll.vue?vue&type=template&id=5b239060&"
import script from "./newOrderAll.vue?vue&type=script&lang=js&"
export * from "./newOrderAll.vue?vue&type=script&lang=js&"
import style0 from "./newOrderAll.vue?vue&type=style&index=0&id=5b239060&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports